/*!
 * Copyright 2025 - Swiss Data Science Center (SDSC)
 * A partnership between École Polytechnique Fédérale de Lausanne (EPFL) and
 * Eidgenössische Technische Hochschule Zürich (ETHZ).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  GetSearchQueryApiArg,
  GetSearchQueryApiResponse,
  searchV2GeneratedApi,
} from "./searchV2Api.generated-api";

// Fixes some API endpoints
export const searchV2Api = searchV2GeneratedApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getSearchQuery: build.query<
      GetSearchQueryApiResponse,
      GetSearchQueryApiArg
    >({
      query: ({ params }) => ({
        url: "/search/query",
        params,
      }),
      providesTags: ["SearchV2"],
    }),
  }),
});

export const { useGetSearchQueryQuery } = searchV2Api;

export type * from "./searchV2Api.generated-api";
